import React from "react";
import { Link } from "react-router-dom";
import { SITE, waLink } from "@/data/site";
import { MapPin, Phone, MessageCircle, Mail, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[hsl(222_47%_9%)] text-slate-200 overflow-hidden grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={SITE.logo} alt="Rightway Finance" className="w-14 h-14 rounded-full object-cover ring-1 ring-white/20"/>
              <div>
                <p className="font-display text-2xl text-white leading-none">Rightway Finance</p>
                <p className="font-mono text-[10px] tracking-[0.24em] uppercase text-slate-400 mt-1.5">Since {SITE.since}</p>
              </div>
            </div>
            <p className="chapter-index text-emerald-400 mt-8">Get In Touch</p>
            <h3 className="font-display text-4xl md:text-6xl leading-[0.95] mt-4 text-white">
              Ready to move<br/>your business forward?
            </h3>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/apply" data-testid="footer-apply-btn" className="btn-line inline-flex items-center rounded-full bg-emerald-500 hover:bg-emerald-400 text-slate-900 px-6 py-3 text-sm font-medium transition-colors">Apply for a Loan</Link>
              <a href={waLink()} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full border border-white/20 hover:border-white/50 text-white px-6 py-3 text-sm transition-colors">
                <MessageCircle size={16}/> WhatsApp Us
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[.2em] text-slate-400">Company</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/about" className="hover:text-emerald-300">About Us</Link></li>
              <li><Link to="/products" className="hover:text-emerald-300">All Loan Products</Link></li>
              <li><Link to="/partnership" className="hover:text-emerald-300">Dealer & Broker Partnership</Link></li>
              <li><Link to="/blog" className="hover:text-emerald-300">Blog</Link></li>
              <li><Link to="/contact" className="hover:text-emerald-300">Contact</Link></li>
              <li><Link to="/privacy" className="hover:text-emerald-300">Privacy & Terms</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[.2em] text-slate-400">Reach Us</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-emerald-400"/> {SITE.city}<br/>Branches: {SITE.branches.join(", ")}</li>
              <li className="flex items-center gap-3"><Phone size={16} className="text-emerald-400"/> <a href={`tel:${SITE.phoneRaw}`} className="hover:text-emerald-300">{SITE.phone}</a></li>
              <li className="flex items-center gap-3"><Phone size={16} className="text-emerald-400"/> <a href={`tel:${SITE.supportRaw}`} className="hover:text-emerald-300">{SITE.support} (support)</a></li>
              <li className="flex items-center gap-3"><Mail size={16} className="text-emerald-400"/> <a href="mailto:admin@rightwayfinance.co" className="hover:text-emerald-300">admin@rightwayfinance.co</a></li>
              <li className="flex items-center gap-3"><Instagram size={16} className="text-emerald-400"/> <a href={SITE.instagram} target="_blank" rel="noreferrer" className="hover:text-emerald-300">@rightway.finance</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-xs text-slate-400 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p>© {new Date().getFullYear()} {SITE.legal}. All rights reserved.</p>
          <p className="max-w-2xl">Loan approval is at the sole discretion of the lender and is subject to documentation, credit assessment and RBI norms. Rightway Finance is a channel partner and does not guarantee loan approval.</p>
        </div>
      </div>
      <div className="absolute -bottom-24 left-0 right-0 pointer-events-none select-none opacity-[0.08]">
        <p className="font-display text-[22vw] leading-none text-white text-center">Rightway</p>
      </div>
    </footer>
  );
}
